<template>
  <div class="grounp-footer" :class="{'pd-34':iosx}">
    <div class="footer-item" @click="goPage('/grouprob/a')">
      <img :src="path !== '/grouprob/mine' ? grounp_shop_activate_icon : grounp_shop_icon" alt="">
      <div>商城</div>
    </div>
    <div class="footer-item" @click="goPage('/grouprob/mine')">
      <img :src="path == '/grouprob/mine' ? grounp_mine_activate_icon: grounp_mine_icon" alt="">
      <div>我的</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'grounpFooter',
    props: {
      path: {
        path: [String, Array],
        default: ''
      }
    },
    data () {
      return {
        grounp_shop_icon: require('@/assets/groupRob/group-shop.png'),
        grounp_mine_icon: require('@/assets/groupRob/group-mine.png'),
        grounp_shop_activate_icon: require('@/assets/groupRob/group-shop-activate.png'),
        grounp_mine_activate_icon: require('@/assets/groupRob/group-mine-activate.png'),
      }
    },
    created () {
      this.iosx = this.isIphoneX()
    },
    methods: {
      goPage (path) {
        if ((this.$route.path == '/grouprob/a' || this.$route.path == '/grouprob/b') && path == '/grouprob/a') {
          return
        }
        if (this.$route.path == '/grouprob/mine' && path == '/grouprob/mine') {
          return
        }
        this.$router.push({
          path
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .grounp-footer {
    display: flex;
    background-color: #fff;


    .footer-item {
      height: 49px;
      flex: 1;
      text-align: center;

      img {
        margin-top: 5px;
        width: 25px;
        height: 25px;
      }

      div {
        height: 14px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 14px;
      }
    }
  }

  .pd-34 {
    padding-bottom: 34px;
  }
</style>